import React, { useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const BREADCRUMB_LABELS = {
   dashboard: "Dashboard",
   user: "User",
   "fleet-master": "Fleet Master",
   "driver-master": "Driver Master",
   "helper-master": "Helper Master",
   "customer-master": "Customer Master",
   "vendor-master": "Vendor Master",
   "lane-master": "Lane Master",
   "contractor-master": "Contractor Master",
   "location-master": "Location Master",
   trip: "Trip",
   "adhoc-lane": "Adhoc Lane",
   "adhoc-vendor": "Adhoc Vendor",
   contractual: "Contractual",
   adhoc: "Adhoc",
   add: "Add",
   "add-form": "Add",
   "add-user": "Add User",
   list: "List",
   view: "View",
   edit: "Edit",
   profile: "Profile",
};

const formatLabel = (segment) => {
   if (/^\d+$/.test(segment)) {
      return "Details";
   }

   if (BREADCRUMB_LABELS[segment]) {
      return BREADCRUMB_LABELS[segment];
   }

   return segment.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
};

const BodyHeader = () => {
   const location = useLocation();

   const breadcrumbs = useMemo(() => {
      const pathSegments = location.pathname.split("/").filter(Boolean);

      return pathSegments.map((segment, index) => ({
         path: `/${pathSegments.slice(0, index + 1).join("/")}`,
         label: formatLabel(segment),
         isLast: index === pathSegments.length - 1,
      }));
   }, [location.pathname]);

   if (breadcrumbs.length === 0) {
      return null;
   }

   return (
      <div className="content-header wis-content-header">
         <div className="container-fluid">
            <div className="wis-breadcrumb-row">
               <ol className="breadcrumb wis-breadcrumb mb-0">
                  <li className="breadcrumb-item">
                     <Link to="/dashboard">Home</Link>
                  </li>
                  {breadcrumbs.map((breadcrumb, index) => (
                     <li
                        className={`breadcrumb-item ${breadcrumb.isLast ? "active" : ""}`}
                        key={`${breadcrumb.path}-${index}`}
                     >
                        {breadcrumb.isLast ? (
                           <span>{breadcrumb.label}</span>
                        ) : (
                           <Link to={breadcrumb.path}>{breadcrumb.label}</Link>
                        )}
                     </li>
                  ))}
               </ol>
            </div>
         </div>
      </div>
   );
};

export default BodyHeader;
